import Common from '../../../Common';

const Permission = class extends Common {
	async read(userId: id) {
		return this.get(
			"/user/{userId}/acl/permission"
			.replace('{userId}', userId + '')
		);
	}
}

export default Permission;
